// extracted by mini-css-extract-plugin
export default {"table":"styles_table__u7PBZ","customPagination":"styles_customPagination__Pcagb","currentPage":"styles_currentPage__XO17z"};